import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { DatamanagementService } from "./shared/datamanagement.service";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { LoanService } from "../../loan/shared/loan.service";
import { CustomerService } from "../../customer/shared/customer.service";
import { SavingsService } from "../../savings/shared/savings.service";
import { CenterlinkService } from "../../customer/shared/centerlink.service";
import { Feestype } from "../../helpers/feestype";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationdialogService } from "../../utility/shared/confirmationdialog.service";

@Component({
  selector: 'app-datamanagement',
  templateUrl: './datamanagement.component.html',
  styleUrls: ['./datamanagement.component.css']
})
export class DatamanagementComponent implements OnInit {

  AddButtonText: string = 'Add';
  // empformbtn: string = 'Save'; 
  ErrorText: string;
  addForm: FormGroup;
  btnvisibility: boolean = true;
  readonlyTextBox: boolean = false;
  isSavingsDisabled = true;
  isLoanDisabled: boolean = false;

  CustomerId: number;
  LoanTypeList: any[] = [];
  CustomerList: any[] = [];
  SchemeList: any[] = [];
  SavingSchemeList: any[] = [];
  DepositTypeList: any[] = [];
  LoanPurposeList: any[] = [];
  GroupCustomersList: any[] = [];
  InterestPercentage: number;
  CentreList: any[] = [];
  MemberGroupList: any[] = [];
  Loading: boolean = false;
  toast: Toastpayload;

  constructor(private formBuilder: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private datamanagementService: DatamanagementService,
    private commonmastersService: CommonmastersService,
    private loanService: LoanService,
    private savingsService: SavingsService,
    private centerlinkService: CenterlinkService,
    private customerService: CustomerService,
    private toasterserviceService: ToasterserviceService,
    private ngxLoader: NgxUiLoaderService,
    private confirmationdialogService: ConfirmationdialogService,
  ) { }

  ngOnInit() {

    this.resetForm();
    this.GetAutogeneratedNumber();
    this.GetScheme();
    this.GetSavingScheme();
    this.GetSavingTypeList();
    this.GetLoanType();
    this.GetLoanPurpose();
    this.GetCustomer();
    this.GetCentreList();

    this.isSavingsDisabled = true;
    this.addForm.controls['CustomerInstallment'].disable();
    this.addForm.controls['Id'].setValue(0);
    this.addForm.controls['Flag'].setValue(1);
    this.addForm.controls['IsActive'].setValue(true);
  }

  resetForm() {
    this.Loading = false;  // loading spinner 
    this.addForm = this.formBuilder.group({
      Id: [],
      CustomerApplicationNo: [],
      CustomerTransactionNo: [],
      CustomerNameId: [0, Validators.required],
      SchemeType: [],
      CustomerBranch: [],
      CustomerAddress: [],
      CustomerProof: [],
      CustomerLoanId: [],
      CustomerinputInterest_Amount: [],
      // CustomerLoanAmount: ['', [Validators.required, Validators.maxLength(4)]],  
      CustomerLoanAmount: [],  // no validation because enable or disable 
      CustomerSchemeId: 0,
      CustomerPrincipleAmount: [],
      CustomerInterestAmount: [],
      CustomerLoanPurpose: 0,
      CustomerLoanApprovedDate: [],
      CustomerWitnessId: 0,

      CustomerSavingsNo: [],
      CustomerDepositAmount: [],
      // CustomerDepositAmount:{value: 100, disabled: false},
      CustomerDepositTypeId: 0,
      CustomerDepositSchemeId: 0,
      CustomerInterestRate: [],
      CustomerMaturity: [],
      CustomerBalanceAmount: [],
      CustomerSavingsDate: [],

      CustomerSavingsPrincipleAmount: [],
      CustomerSavingsInterestAmount: [],
      CustomerPreviousSavingsAmount: [],

      CustomerCentreId: [0, Validators.required],
      CustomerGroupId: [0, Validators.required],
      CustomerAdmissionFee: [Feestype.AdmissionFee],
      CustomerInstallment: [],
      IsSavingsCustomer: [false],
      CustomerDDFund: [Feestype.DDFund],
      IsOpening: [true],

      Flag: [1],
      IsActive: [true],
    });
    this.GetAutogeneratedNumber(); // Re-Generating Transaction No

    this.isLoanDisabled = false;  // saving customer selected
    this.isSavingsDisabled = true;
    this.btnvisibility = true;

    this.addForm.controls['CustomerInstallment'].enable();
  }


  onSubmit() {

    this.Loading = true;  // loading spinner 
    let ReturnLoadId = 0, ReturnSavingsId = 0, ReturnMsg = "";

    this.toast = {
      message: "No Message Now!",
      title: 'Loan Collection.!',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    // showing Loader 
    // this.ngxLoader.start(); not working now
    this.ErrorText = "";
    //conformation dialog box
    let title: string = "Ready to submit?";
    let message: string = "Please check all the entries are correct before saving. Do you want to continue?";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed => {
        if (confirmed == true) {

          // Checking Customer with Loan and savings 
          if (!this.addForm.value.IsSavingsCustomer) {

            this.btnvisibility = false; // for restrict multiple press
            // Check whether Loan Approved Date is null.
            if (this.addForm.value.CustomerLoanApprovedDate != null) {
              // Check whether Loan LoanAmount is null.
              if (this.addForm.value.CustomerLoanAmount !== null && this.addForm.value.CustomerLoanAmount !== '0') {
                let IsCentreLinkPromise = this.CentreLinkbyId();
                IsCentreLinkPromise.then((val) => {
                  if (val) {
                    // Customer with Loan and savings  
                    this.datamanagementService.IUDLoan(this.addForm).toPromise()
                      .then(data => {

                        ReturnLoadId = data[0].ResponseId;
                        ReturnSavingsId = data[0].UniqueId; // UniqueId, here we considered as SAVINGS Id from Db.
                        ReturnMsg = data[0].ResponseMessage;

                        if (ReturnLoadId != 0) { // cheking whether the loanId is not null
                          // Load Transaction Entry with LOAN Id.
                          this.datamanagementService.IUDLoantransaction(this.addForm, ReturnLoadId).subscribe(data => { });
                        }
                        else {
                          this.ErrorText = "Loan has not properly saved !";
                          return;
                        }

                        if (ReturnSavingsId != 0) { // cheking whether the loanId is not null
                          // Savings Transaction Entry with SAVINGS Id
                          this.datamanagementService.IUDSavingstransaction(this.addForm, ReturnSavingsId).subscribe(data => { });
                        }
                        else {
                          this.ErrorText = "Savings has not properly saved !";
                          return;
                        }

                        this.resetForm();
                        this.ErrorText = ReturnMsg;
                      });
                  }
                  else {
                    this.ErrorText = "Centre link not properly saved, try once again !";
                    return;
                  }
                });
              }
              else {
                this.ErrorText = "Loan amount cannot be zero/empty ";
                this.Loading = false;  // loading spinner in save button
                return;
              }

            }
            else {
              this.ErrorText = "Choose Loan Approved Date! ";
              this.Loading = false;  // loading spinner in save button
              return;
            }
          }
          else {
            //  Savings only customer  
            // Check whether Deposit Date is null.
            if (this.addForm.value.CustomerSavingsDate != null) {
              // Check whether Deposit Amount is null.
              if (this.addForm.value.CustomerDepositAmount !== null && this.addForm.value.CustomerDepositAmount !== '0') {

                let IsCentreLinkPromise = this.CentreLinkbyId();
                IsCentreLinkPromise.then((val) => {
                  if (val) {
                    this.datamanagementService.IUDSavings(this.addForm).toPromise()
                      .then(data => {

                        // let RetSavingsData =  Promise.resolve(data);
                        // console.log(data);
                        ReturnSavingsId = data[0].ResponseId;
                        // Savings Transaction Entry with SAVINGS Id
                        this.datamanagementService.IUDSavingstransaction(this.addForm, ReturnSavingsId).toPromise().then(data => {

                          this.resetForm();
                          this.ErrorText = 'Savings Saved Successfully';
                        });
                      });
                  }
                  else {
                    this.ErrorText = "Centre link not properly saved, try once again ! ";
                    return;
                  }
                });
              }
              else {
                this.ErrorText = "Deposit amount cannot be zero/empty ";
                this.Loading = false;  // loading spinner in save button
                return;
              }
            }
            else {
              this.ErrorText = "Choose deposit Date! ";
              this.Loading = false;  // loading spinner in save button
              return;
            }

          }
        }
        else {
          this.toast.message = 'Cancelled, need to recheck all the entries.'
          this.toast.type = 'error';
          this.toasterserviceService.showToast(this.toast);

          this.btnvisibility = true; // enable the saving button.
          this.Loading = false;  // cancel loading spinner 
        }
        // Closing Loader
        // this.ngxLoader.stop();
      })
  }

  // not using now!
  IUDLoanWithSavingsCustomer(): any {

    var out;
    // Checking Customer with Loan and savings 
    if (!this.addForm.value.IsSavingsCustomer) {

      // Check whether Loan Approved Date is null.
      if (this.addForm.value.CustomerLoanApprovedDate != null) {

        // Customer with Loan and savings  
        out = this.datamanagementService.IUDLoan(this.addForm).toPromise()
          .then(data => {

            // ReturnLoadId = data[0].ResponseId;
            // ReturnSavingsId = data[0].UniqueId; // UniqueId, here we considered as SAVINGS Id from Db.
            // ReturnMsg = data[0].ResponseMessage;
            return Promise.resolve(data[0]);
          });
      }
    }
    return out;
  }

  // not using now!
  IUDLoantransaction(outLoadId): any {

    if (outLoadId != 0) { // cheking whether the loanId is not null
      // Load Transaction Entry with LOAN Id.
      this.datamanagementService.IUDLoantransaction(this.addForm, outLoadId).subscribe(data => { });
    }
    else {
      this.ErrorText = "Loan has not properly saved !";
      return;
    }
  }

  // not using now!
  IUDSavingstransaction(outSavingsId): any {

    if (outSavingsId != 0) { // cheking whether the loanId is not null
      // Savings Transaction Entry with SAVINGS Id
      this.datamanagementService.IUDSavingstransaction(this.addForm, outSavingsId).subscribe(data => { });
    }
    else {
      this.ErrorText = "Savings has not properly saved !";
      return;
    }
  }

  GetScheme() {
    this.commonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;
    })
  }

  GetLoanType() {
    this.commonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetLoanPurpose() {
    this.commonmastersService.FetchLoanPurpose().subscribe(data => {
      this.LoanPurposeList = data;
    })
  }

  GetCustomer() {
    this.customerService.FetchCustomerList().toPromise().then(data => {
      this.CustomerList = data;
    })
  }

  GetGroupCustomersList(memberGroupId: any) {
    this.GroupCustomersList = this.CustomerList.filter(item => item.GroupId == memberGroupId);
  }

  GetSavingTypeList() {
    this.commonmastersService.FetchDepositTypeList().subscribe(data => {
      this.DepositTypeList = data;
    })
  }

  GetSavingScheme() {
    this.savingsService.FetchSavingsSchemeList().subscribe(data => {
      this.SavingSchemeList = data;
    })
  }

  public SelectSchemeChange(SchemeId: any) {
    this.loanService.FetchSchemeBySchemeId(SchemeId).subscribe(data => {

      this.InterestPercentage = data.InterestPrecentage; // finding interest amount

      if (this.addForm.value.CustomerLoanAmount != null) {

        let InterestAmount = (this.addForm.value.CustomerLoanAmount * (this.InterestPercentage / 100));
        this.addForm.controls['CustomerinputInterest_Amount'].setValue(InterestAmount);

        // let Maturity =  this.datePipe.transform(new Date(Date.now()  + (numWeeks * 6.048e+8)), 'dd/MM/yyyy').toString();
        // this.savingsService.selectedSavings.MaturityDate = new Date(Date.now()  + (numWeeks * 6.048e+8));
      }
    })
  }

  GetCentreList() {
    this.centerlinkService.GetCentreList()
      .toPromise()
      .then(data => {
        this.centerlinkService.selectedCenterlinkList = data;
        this.CentreList = data;
      })
  }

  selectChangeMember(centreId: any): void {
    this.ErrorText = "";
    this.GetMemberGroupList(centreId);
  }

  GetMemberGroupList(id: any) {

    this.centerlinkService.GetMemberGroupList(id)
      .toPromise()
      .then(data => {

        this.MemberGroupList = data;
        this.centerlinkService.selectedCenterlink.GroupId = data[0].Id;
      })
  }

  ClickIsSavings(event: any) {
    this.isSavingsDisabled = this.addForm.value.IsSavingsCustomer ? true : false;
    this.isLoanDisabled = this.addForm.value.IsSavingsCustomer ? false : true;
    this.addForm.value.IsSavingsCustomer ? this.addForm.controls['CustomerInstallment'].disable() : this.addForm.controls['CustomerInstallment'].enable();
  }

  GetCustometDetail(event: any) {
    this.addForm.controls['CustomerBranch'].setValue(event.CustomerBranchName);
    this.addForm.controls['CustomerAddress'].setValue(event.Address);
    this.addForm.controls['CustomerProof'].setValue(event.IdProofNo);
  }

  GetAutogeneratedNumber(): any {
    let AutoGeneratedNo = this.commonmastersService.FetchAutogeneratedNumber()
      .toPromise()
      .then(res => {

        this.addForm.controls['CustomerApplicationNo'].setValue(res[0].AutoGeneratedId);
        this.addForm.controls['CustomerTransactionNo'].setValue(res[0].AutoGeneratedId);
        return Promise.resolve(res[0].AutoGeneratedId);
      })
      .catch(err => { console.log(err) });
    AutoGeneratedNo.then(function (val) {
      // console.log(val);   
    });
  }

  CentreLinkbyId() {

    let promise = new Promise<boolean>((resolve, reject) => {

      this.datamanagementService.IUDCentreLink(this.addForm)
        .toPromise()
        .then(data => {
          setTimeout(function () {
            if (data !== null) {
              // data generated and return
              resolve(true)
            }
            else {
              reject(false)
            }
          }, 5000);
        })
        .catch(err => {
          console.log(err + '- Iud centrelink')
          reject(false)
        });
    });
    return promise;
  }

}